import type { CommissionLineNode } from "../lines/types";
import { commissionCampaignFixtures } from "./fixtures";

function campaignSummary(campaignId: string) {
  const campaign = commissionCampaignFixtures.find((node) => node.id === campaignId);
  if (!campaign) {
    throw new Error(`Missing campaign fixture for ${campaignId}`);
  }

  return {
    id: campaign.id,
    editionYear: campaign.editionYear,
    partner: campaign.partner,
    program: campaign.program
  };
}

export const commissionLineFixtures: CommissionLineNode[] = [
  {
    id: "commission-line-1",
    person: { id: "person-ada", pgaId: "12345678", displayName: "Ada Lovelace" },
    amountCents: 125000,
    fundingStatus: "PENDING",
    payoutEligibilityStatus: "HELD",
    holdReasons: ["awaiting_sponsor_funding", "missing_faa"],
    lineKind: "INGEST",
    receivedAt: "2026-03-15T14:22:00Z",
    payableAt: null,
    paidOutAt: null,
    splitLines: [{ id: "commission-line-2" }],
    campaign: campaignSummary("commission-campaign-2026-acme")
  },
  {
    id: "commission-line-2",
    person: { id: "person-grace", pgaId: "87654321", displayName: "Grace Hopper" },
    amountCents: 98000,
    fundingStatus: "INVOICED",
    payoutEligibilityStatus: "HELD",
    holdReasons: ["awaiting_sponsor_funding"],
    lineKind: "INGEST",
    receivedAt: "2026-03-10T09:00:00Z",
    campaign: campaignSummary("commission-campaign-2026-acme")
  },
  {
    id: "commission-line-3",
    person: { id: "person-alan", pgaId: "11223344", displayName: "Alan Turing" },
    amountCents: 200000,
    fundingStatus: "FUNDED",
    payoutEligibilityStatus: "PAYABLE",
    holdReasons: [],
    lineKind: "INGEST",
    receivedAt: "2026-02-01T09:10:00Z",
    payableAt: "2026-02-15T10:00:00Z",
    paidOutAt: null,
    fundingBatch: { id: "funding-batch-1", status: "FUNDED" },
    splitLines: [],
    campaign: campaignSummary("commission-campaign-2026-acme")
  },
  {
    id: "commission-line-4",
    person: { id: "person-katherine", pgaId: "55667788", displayName: "Katherine Johnson" },
    amountCents: 150000,
    fundingStatus: "FUNDED",
    payoutEligibilityStatus: "PAID_OUT",
    holdReasons: [],
    lineKind: "INGEST",
    receivedAt: "2026-01-20T11:30:00Z",
    payableAt: "2026-01-25T09:00:00Z",
    paidOutAt: "2026-02-01T12:00:00Z",
    releaseBatch: { id: "release-batch-1", status: "COMPLETED" },
    splitLines: [],
    campaign: campaignSummary("commission-campaign-2026-fairway")
  },
  {
    id: "commission-line-5",
    person: { id: "person-margaret", pgaId: "99887766", displayName: "Margaret Hamilton" },
    amountCents: 75000,
    fundingStatus: "PENDING",
    payoutEligibilityStatus: "ACCRUED",
    holdReasons: [],
    lineKind: "ADJUSTMENT",
    receivedAt: "2026-03-16T08:00:00Z",
    campaign: campaignSummary("commission-campaign-2026-fairway")
  }
];
